import AdminDashboard from './AdminDashboard';

// ===========================|| MENU ITEMS ||=========================== //

const menuItems = {
    items: [AdminDashboard],
};

export default menuItems;
